<script lang="ts">
	import { LABEL, STAT_TILE } from '@papyria/ui';
	import * as m from '#lib/paraglide/messages.js';

	const points = [
		{ title: m.pitch_rules_title(), body: m.pitch_rules_body() },
		{ title: m.pitch_ai_title(), body: m.pitch_ai_body() },
		{ title: m.pitch_word_title(), body: m.pitch_word_body() }
	];
</script>

<ul class="grid grid-cols-[repeat(auto-fit,minmax(min(240px,100%),1fr))] gap-4">
	{#each points as point, index (point.title)}
		<li class="{STAT_TILE} flex flex-col gap-1.5">
			<p class={LABEL}>0{index + 1} / {point.title}</p>
			<p class="text-sm leading-relaxed text-ink">{point.body}</p>
		</li>
	{/each}
</ul>
